module.exports = "<p>\r\n  faq works!\r\n</p>\r\n"